
export default function ExerciserResultsContentLayout({children}) {
    // Used in

    // BUILD
    return (
        <div className={"overflow-auto bg-backgroundLight3 w-full grow flex flex-col items-center"}>
            {children}
        </div>
    );
}